import { render, staticRenderFns } from "./live-drawer.vue?vue&type=template&id=8cacd6e4&"
import script from "./live-drawer.vue?vue&type=script&lang=js&"
export * from "./live-drawer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports